import { t } from "@lingui/macro";
import { useSetAtom } from "jotai";

import { ClubSwitcherIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  HStack,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { setOwnerAtom } from "../../../../../../../../../atoms/actions/SetOwnerAtom/setOwnerAtom";

export const SetOwnerMenuItem = ({
  roundId,
  closeMenu,
}: {
  roundId: string;
  closeMenu: () => void;
}) => {
  const setOwner = useSetAtom(setOwnerAtom);
  return (
    <Pressable
      onPress={() => {
        setOwner({ roundId });
        closeMenu();
      }}
    >
      <HStack gap={3} paddingHorizontal={4} paddingVertical={3}>
        <ClubSwitcherIcon />
        <Text>{t`Set as Owner`}</Text>
      </HStack>
    </Pressable>
  );
};
